import { ApplyScheduleTemplateBody } from "@common/schemas/domains/accounting/scheduleApplication.schema";
import { ScheduleSourceType } from "@common/types/domains/accounting/schedule";
import {
    ScheduleSpecificDateApplyRequest,
    ScheduleSpecificDateApplyResult,
} from "@components/accounting/schedules/manual/scheduleSpecificDateApply";
import { buildAccruedBilling } from "@components/accounting/schedules/scheduleApplyAccruedHelpers";

/** The apply body for a transaction, carrying what the date modal collected. */
export function buildTransactionSchedulePayload(options: {
    entityId: number;
    transactionId: number;
    amount: number;
    specificDateApply?: ScheduleSpecificDateApplyResult;
}): ApplyScheduleTemplateBody {
    return {
        sourceType: ScheduleSourceType.transaction,
        entityId: options.entityId,
        transactionId: options.transactionId,
        amount: Math.abs(options.amount),
        ...options.specificDateApply,
    };
}

/** What the schedule modal needs to collect a start date for one transaction. */
export function buildTransactionSpecificDateRequest(options: {
    template: { id: string; name: string };
    entityId: number;
    transactionId: number;
    amount: number;
    label: string;
    dateOnly: string | null | undefined;
}): ScheduleSpecificDateApplyRequest {
    const amount = Math.abs(options.amount);
    const sourceDate = options.dateOnly ?? null;
    return {
        templateId: options.template.id,
        templateName: options.template.name,
        entityId: options.entityId,
        sourceType: ScheduleSourceType.transaction,
        amount,
        sourceLabel: options.label,
        sourceKey: String(options.transactionId),
        sourceDate,
        billing: buildAccruedBilling({
            sourceDate,
            amount,
            noun: "Payment",
        }),
    };
}
